import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/(all)/lucky-wheel/template.tsx");
